import React from "react"
import { defaultMarkdownElements } from "@internal/ui"
import type { ContentNode } from "../renderer/types"
import { AccordionContent } from "./accordion-content"
import { BlockQuoteContent } from "./block-quote-content"
import { ContentBlockContent } from "./content-block-content"
import { ContentBlockWithIconContent } from "./content-block-with-icon-content"
import { TwoColumnBulletListContent } from "./two-column-bullet-list-content"
import { TwoColumnLayoutContent } from "./two-column-layout-content"
import { UnorderedListContent } from "./unordered-list-content"
import { ModalContent } from "./modal-content"
import { BannerImageContent } from "./banner-image-content"
import { DiagramContent } from "./diagram-content"

export function ContentItem({ content }: { content: ContentNode }) {
  switch (content.type) {
    case "accordion":
      return <AccordionContent content={content} />
    case "blockQuote":
      return <BlockQuoteContent content={content} />
    case "container":
      return <ContentList contents={content.content} />
    case "contentBlock":
      return <ContentBlockContent content={content} />
    case "contentBlockWithIcon":
      return <ContentBlockWithIconContent content={content} />
    case "twoColumnBulletList":
      return <TwoColumnBulletListContent content={content} />
    case "twoColumnLayout":
      return <TwoColumnLayoutContent content={content} />
    case "unorderedList":
      return <UnorderedListContent content={content} />
    case "modal":
      return <ModalContent content={content} />
    case "bannerImage":
      return <BannerImageContent content={content} />
    case "diagram":
      return <DiagramContent content={content} />
    default:
      return null
  }
}

export function ContentList({ contents, asList }: { contents: ContentNode[]; asList?: boolean }) {
  return (
    <>
      {contents.map((item) =>
        asList ? (
          <defaultMarkdownElements.li.component key={item.id} {...defaultMarkdownElements.li.props}>
            <ContentItem content={item} />
          </defaultMarkdownElements.li.component>
        ) : (
          <ContentItem key={item.id} content={item} />
        )
      )}
    </>
  )
}
